import { AppLayout } from "@/components/layout/AppLayout";
import { DatasetNav } from "@/raw/components/DatasetNav";
import { rawDatasetMetas } from "@/raw/datasets/registry";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export function RawLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeDataset =
    rawDatasetMetas.find((dataset) => dataset.route === location.pathname) ?? rawDatasetMetas[0]!;

  return (
    <AppLayout contentClassName="px-4 pb-8 sm:px-6">
      <div className="mx-auto flex min-h-[calc(100dvh-4rem)] max-w-[1400px] gap-6 py-4">
        <aside className="hidden w-52 shrink-0 md:block">
          <p className="mb-3 px-3 text-xs font-semibold uppercase tracking-wide text-[var(--color-text-muted)]">
            Datasets
          </p>
          <DatasetNav />
        </aside>

        <main className="min-w-0 flex-1">
          <div className="mb-4 flex flex-wrap items-center gap-3 md:hidden">
            <Select
              value={activeDataset.id}
              onValueChange={(datasetId) => {
                const dataset = rawDatasetMetas.find((entry) => entry.id === datasetId);
                if (dataset) navigate(dataset.route);
              }}
            >
              <SelectTrigger className="min-w-40">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {rawDatasetMetas.map((dataset) => (
                  <SelectItem key={dataset.id} value={dataset.id}>
                    {dataset.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Outlet />
        </main>
      </div>
    </AppLayout>
  );
}
